
















































import { Vue, Component, Watch } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { TbShop, TbShopAccount,TbTbHandover } from '@/http';
import { Toast,Dialog } from 'vant';

import {State,Getter,Action,Mutation,namespace} from 'vuex-class'
import levelSet from './vip/components/levelSet.vue';
import { addByjPanel } from "@/components";
var md5 = require("js-md5");
@Component({
    components: {
        addByjPanel
    },
})
export default class LoginPage extends Vue {

    form={
        /**店铺编号 */
        shopno:"",
        /**员工号 */
        jobNumber:"",
        /**密码 */
        pwd:"",
    }

    checked=false;
    isLoading=false;

    /**备用金弹窗 */
    addimprestShow = false;

    async mounted() {
        let jwt = localStorage.getItem('padToken')?localStorage.getItem('padToken'):'';
        if(jwt){
            let shopInfo = localStorage.getItem('padShopInfo')?JSON.parse(localStorage.getItem('padShopInfo')):null;
            console.log('window.webkit',window.webkit)
            if(window.webkit){
                let pageSize = localStorage.getItem('labelPaperSize');
                if(pageSize){
                    window.webkit.messageHandlers.setPageSize.postMessage(pageSize);
                }else{
                    let userInfo =  JSON.parse(localStorage.getItem('padUserinfo'));
                    if(userInfo.isJewelry){
                        window.webkit.messageHandlers.setPageSize.postMessage(3);
                    }else{
                        window.webkit.messageHandlers.setPageSize.postMessage(1);
                    }

                }
                window.webkit.messageHandlers.searchForBluetooth.postMessage('searchForBluetooth');
                window.webkit.messageHandlers.getVersion.postMessage('getVersion');
            }
            if(shopInfo){
                let resShop = await TbShop.GetTbShopById({id:shopInfo.id})
                if(!resShop.isUpdate){
                    this.$router.push("/pad/shopUpdate");
                }else{
                    this.$router.push("/pad/mainPage/index");
                }
            }
        }else{
          let loginInfo = localStorage.getItem("loginInfo")? JSON.parse(localStorage.getItem("loginInfo")):null;
          if(loginInfo){
            this.checked = localStorage.getItem("isRememberPwd") && localStorage.getItem("isRememberPwd") == "true" ? true : false;
            this.form.shopno = loginInfo.shopNo;
            if (this.checked) {
                this.form.jobNumber = loginInfo.jobNumber;
                this.form.pwd = loginInfo.pwd;
            } else {
                 this.form.jobNumber = loginInfo.jobNumber;
                this.form.pwd = "";

            }
          }
        }
    }
    async created() {

    }
    async loginFun(){
        if(this.isLoading)return;
        if(!this.form.shopno){
            Toast("请输入店铺编号")
            return;
        }
        if(!this.form.jobNumber){
            Toast("请输入手机号/员工号")
            return;
        }
        if(!this.form.pwd){
            Toast("请输入密码")
            return;
        }
        this.isLoading = true;
        try {
            let res = await TbShopAccount.GetWebUsersLogin({
                shopno:this.form.shopno,
                jobNumber:this.form.jobNumber,
                pwd:md5(this.form.pwd),
            });
            localStorage.setItem("padToken",res.token);
            localStorage.setItem("padUserinfo",JSON.stringify(res));
            // if(window.webkit){
            //     if(res.isJewelry){
            //         window.webkit.messageHandlers.setPageSize.postMessage(3);
            //     }else{
            //         window.webkit.messageHandlers.setPageSize.postMessage(1);
            //     }
            //     window.webkit.messageHandlers.searchForBluetooth.postMessage('searchForBluetooth');
            // }
            localStorage.setItem("appAuth",res.appAuth);
            let resShop = await TbShop.GetTbShopById({id:res.shopId})
            localStorage.setItem("padShopInfo",JSON.stringify(resShop))
            let form = Object.assign({},res,{
                pwd:this.form.pwd,
                shopNo:resShop.shopNo
            })
            localStorage.setItem("loginInfo",JSON.stringify(form));
            let resVersion = await TbShopAccount.GetVersion({versionType:4});
            localStorage.setItem('versionIno',JSON.stringify(resVersion));
            if(this.checked){
                localStorage.setItem("isRememberPwd",'true')
            }else{
                localStorage.setItem("isRememberPwd",'false')
            }

            if(localStorage.getItem('loginEdList')){
                let loginEdList = localStorage.getItem('loginEdList')? JSON.parse(localStorage.getItem('loginEdList')):{};
                if(resShop.shopNo==loginEdList.shopNo){
                    let index = loginEdList.list.findIndex(v=>v.jobNumber==this.form.jobNumber)
                    if(index>-1){
                        loginEdList.list[index].jobNumber = this.form.jobNumber;
                        loginEdList.list[index].pwd = this.form.pwd;
                        loginEdList.list[index].isRemeber = this.checked;
                    }else{
                        loginEdList.list.push({
                            pwd:this.form.pwd,
                            jobNumber:this.form.jobNumber,
                            isRemeber:this.checked
                        })
                    }
                    localStorage.setItem('loginEdList',JSON.stringify(loginEdList));
                }else{
                    localStorage.removeItem('loginEdList');
                    let obj = {
                        shopNo:resShop.shopNo,
                        list:[{
                            pwd:this.form.pwd,
                            jobNumber:this.form.jobNumber,
                            isRemeber:this.checked
                        }]
                    }
                localStorage.setItem('loginEdList',JSON.stringify(obj));
                }
            }else{
                let obj = {
                        shopNo:resShop.shopNo,
                        list:[{
                            pwd:this.form.pwd,
                            jobNumber:this.form.jobNumber,
                            isRemeber:this.checked
                        }]
                    }
                localStorage.setItem('loginEdList',JSON.stringify(obj));
            }
            this.isLoading = false;
            if(!res.isUpdate){
                this.$router.push("/pad/shopUpdate");
            }else{
                /**是否开启备用金 */
                let resByj = await TbShop.GetInitShopInfo({shopId:JSON.parse(localStorage.getItem('padShopInfo')).id});
                if(resByj.isOpenImprest){
                    // 登录成功后，判断登录账号的“是否已交接班”状态；
                    let resIsjjb = await TbTbHandover.GetHandowerTime({
                        accountId:JSON.parse(localStorage.getItem("padUserinfo")).id,
                    });
                    if(resIsjjb.startTime) {
                        let resAddByj = await TbShopAccount.AddTbImprest({
                            handoverId:JSON.parse(localStorage.getItem("padUserinfo")).id,
                            money:0
                        });
                        this.$router.push("/pad/mainPage/index");
                    }else{
                        this.addimprestShow = true;
                    }
                }else{
                    let resAddByj = await TbShopAccount.AddTbImprest({
                        handoverId:JSON.parse(localStorage.getItem("padUserinfo")).id,
                        money:0
                    });
                    this.$router.push("/pad/mainPage/index");
                }
            }


            // if(window.webkit){
            //     window.webkit.messageHandlers.getVersion.postMessage('getVersion');
            // }
        } catch (error) {
            this.isLoading = false;
        }
    }
    closeFun(){
        this.addimprestShow = false;
        this.$router.push("/pad/mainPage/index");
    }


}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/Login.vue